
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpen, Zap, Flag, Calendar, ArrowRight } from 'lucide-react';
import { toast } from 'sonner';

const ChallengeMenu = () => {
    const navigate = useNavigate();

    const challengeModes = [
        {
            id: 'classic',
            name: 'Classic',
            icon: BookOpen,
            description: '50 questions, 2 hours',
            color: 'bg-blue-500',
            details: 'Full GCE A/L exam simulation. Counts towards ranking.',
            route: '/challenge/classic',
            available: true
        },
        {
            id: 'blitz',
            name: 'Blitz',
            icon: Zap,
            description: '1 question, 2.4 minutes',
            color: 'bg-amber-500',
            details: 'Quick practice session for rapid learning.',
            route: '/challenge/blitz',
            available: true
        },
        {
            id: 'ladder',
            name: 'Ladder',
            icon: Flag,
            description: 'Progressive difficulty',
            color: 'bg-emerald-500',
            details: 'Subject-focused challenges from easy to hard.',
            route: '/challenge/ladder',
            available: true
        },
        {
            id: 'past',
            name: 'Past',
            icon: Calendar,
            description: 'Past exam papers',
            color: 'bg-purple-500',
            details: 'Practice with real GCE A/L past papers.',
            route: '/challenge/past',
            available: false // Change to true when implemented
        },
    ];

    return (
        <div className="min-h-screen pt-20 pb-12 px-6">
            <div className="container mx-auto max-w-6xl">
                <div className="text-center mb-12">
                    <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mb-4">
                        Choose Your Challenge
                    </h1>
                    <p className="text-muted-foreground">
                        Select a challenge mode to start practicing
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {challengeModes.map((mode) => {
                        const Icon = mode.icon;
                        return (
                            <button
                                key={mode.id}
                                onClick={() => {
                                    if (mode.available) {
                                        navigate(mode.route);
                                    } else {
                                        toast.info(`${mode.name} mode coming soon!`);
                                    }
                                }}
                                className="group relative overflow-hidden rounded-2xl border border-border bg-card p-6 text-left transition-all hover:shadow-lg hover:scale-105"
                            >
                                <div className={`absolute top-0 right-0 w-32 h-32 ${mode.color} opacity-10 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-500`} />

                                <div className="relative z-10">
                                    <div className={`inline-flex items-center justify-center w-12 h-12 rounded-xl ${mode.color} bg-opacity-10 mb-4`}>
                                        <Icon className={`w-6 h-6 ${mode.color.replace('bg-', 'text-')}`} />
                                    </div>

                                    <h3 className="text-xl font-bold mb-2">{mode.name}</h3>
                                    <p className="text-sm text-muted-foreground mb-4">{mode.description}</p>
                                    <p className="text-xs text-muted-foreground">{mode.details}</p>

                                    <div className="mt-6 flex items-center text-sm font-medium text-primary">
                                        Start Challenge
                                        <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                                    </div>
                                </div>
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default ChallengeMenu;
